module.exports = __webpack_public_path__ + "img/banner-ai.8a1bd969.png";